import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import * as Icon from 'react-icons/gi';
import LocationTooltips from 'ui/components/data/location';

const manifestType = {
  last_mile: 'Last Mile',
  pickup: 'First Mile',
  console: 'Mid Mile',
  forwarder: 'Forward',
  return: 'Return',
};

const ModaIcon = ({ moda }) => {
  if (moda === 'air_freight') {
    return <Icon.GiCommercialAirplane size={30} />;
  } else if (moda === 'sea_freight') {
    return <Icon.GiCargoShip size={30} />;
  } else {
    return <Icon.GiTruck size={30} />;
  }
};

const ModaDesc = ({ moda, data }) => {
  if (moda === 'air_freight') {
    return (
      <div className="table-col">
        <small className="info text-uppercase">
          SMU: {data?.air_freight?.code_smu}
        </small>
        <small className="info text-uppercase">
          MAN: {data?.air_freight?.no_manifest}
        </small>
      </div>
    );
  } else if (moda === 'sea_freight') {
    return (
      <div className="table-col">
        <div className="text-ellipsis fs-8 fw-semibold">
          {data?.sea_freight?.shipping_company}
        </div>

        {data?.sea_freight?.bl_code && (
          <small className="info text-uppercase">
            BL: {data?.sea_freight?.bl_code}
          </small>
        )}
        {data?.sea_freight?.no_container && (
          <small className="info text-uppercase">
            NOC: {data?.sea_freight?.no_container}
          </small>
        )}
        {data?.sea_freight?.no_segel && (
          <small className="info text-uppercase">
            NOS: {data?.sea_freight?.no_segel}
          </small>
        )}
        {data?.sea_freight?.no_marking && (
          <small className="info text-uppercase">
            NOM: {data?.sea_freight?.no_marking}
          </small>
        )}
      </div>
    );
  } else {
    return (
      <div className="table-col">
        <div className="text-ellipsis fs-8 fw-semibold">
          {data?.air_freight?.airplane}
        </div>
        <small className="info text-uppercase">
          VT: {data?.land_freight?.vehicle_type?.name}
        </small>
        <small className="info text-uppercase">
          DRIVER: {data?.land_freight?.driver?.name}
        </small>
      </div>
    );
  }
};

let table = { ...config };

table.url = '/tms/manifest/report';
table.columns = {
  date: {
    title: 'Tanggal',
    sortable: false,
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="table-col text-center">
          <div className="text-ellipsis">
            {formatDate(row?.schedule_at, 'DD/MM') || '-'}
          </div>
          <small className="text-ellipsis">
            {formatDate(row?.schedule_at, 'YYYY') || '-'}
          </small>
        </div>
      );
    },
  },
  moda: {
    title: 'Moda',
    sortable: false,
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="table-col text-center">
          <ModaIcon moda={row?.moda_type} />
          <small className="info text-uppercase">
            {row?.moda_type?.replace('_', ' ')}
          </small>
        </div>
      );
    },
  },
  code: {
    title: 'Manifest',
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <small className="info text-uppercase">{row?.hub?.name}</small>
          <div className="text-ellipsis fs-8 fw-semibold">
            <span className="me-1">{row?.code}</span>
          </div>
        </div>
      );
    },
  },
  type: {
    title: '',
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="table-col">
          <span className="badge bg-success-lt ms-auto">
            {manifestType[row?.type]}
          </span>
        </div>
      );
    },
  },
  vendor: {
    title: 'Vendor',
    width: 100,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="table-col text-center">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.vendor?.name}
          </div>
        </div>
      );
    },
  },

  driver: {
    title: '',
    sortable: false,
    width: 100,
    component: (row) => {
      return row?.type === 'forwarder' ? null : (
        <ModaDesc moda={row?.moda_type} data={row?.moda} vendor={row?.vendor} />
      );
    },
  },

  shipment: {
    title: 'Shipment',
    width: 100,
    component: (row) => {
      return (
        <div className="text-ellipsis">{row?.order_delivery.shipment.code}</div>
      );
    },
  },
  origin: {
    title: 'Asal',
    width: 150,
    component: (row) => {
      return (
        <div className="table-col ps-2">
          <LocationTooltips data={row?.order_delivery?.shipment?.origin}>
            <div className="row">
              <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                {row?.order_delivery?.shipment?.origin.name}
              </div>
              <small className="info text-ellipsis">
                {row?.order_delivery?.shipment?.origin.region?.district_name},{' '}
                {row?.order_delivery?.shipment?.origin.region?.regency_name},{' '}
                {row?.order_delivery?.shipment?.origin.region?.province_name}
              </small>
            </div>
          </LocationTooltips>
        </div>
      );
    },
  },

  destination: {
    title: 'Destination',
    width: 150,
    component: (row) => {
      return (
        <div className="table-col ps-2">
          <LocationTooltips data={row?.order_delivery?.shipment?.destination}>
            <div className="row">
              <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                {row?.order_delivery?.shipment?.destination.name}
              </div>
              <small className="info text-ellipsis">
                {
                  row?.order_delivery?.shipment?.destination.region
                    ?.district_name
                }
                ,{' '}
                {
                  row?.order_delivery?.shipment?.destination.region
                    ?.regency_name
                }
                ,{' '}
                {
                  row?.order_delivery?.shipment?.destination.region
                    ?.province_name
                }
              </small>
            </div>
          </LocationTooltips>
        </div>
      );
    },
  },
  status: {
    title: 'Status',
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return (
        <span
          className={`badge status-${row?.order_delivery?.shipment?.status}-lt ms-auto`}
        >
          {row?.order_delivery?.shipment?.status?.replace('console', 'Transit')}
        </span>
      );
    },
  },
};

export default table;
